import { useQuery } from "@tanstack/react-query";
import adminApiClient, { CollectionPurchaseStatsResponse } from "api/admin";

export default function useCollectionPurchaseStats(months: number = 12) {
  return useQuery<CollectionPurchaseStatsResponse>({
    queryKey: ["collectionPurchaseStats", months],
    queryFn: () => adminApiClient.getCollectionPurchaseStats(months),
  });
}
